<template>
  <div v-if="isATwilioChannel" class="mx-8">
    <SettingsSection :title="$t('INBOX_MGMT.ADD.TWILIO.API_CALLBACK.TITLE')"
      :sub-title="$t('INBOX_MGMT.ADD.TWILIO.API_CALLBACK.SUBTITLE')">
      <woot-code :script="inbox.callback_webhook_url" lang="html" />
    </SettingsSection>
  </div>
  <div v-else-if="isALineChannel" class="mx-8">
    <SettingsSection :title="$t('INBOX_MGMT.ADD.LINE_CHANNEL.API_CALLBACK.TITLE')"
      :sub-title="$t('INBOX_MGMT.ADD.LINE_CHANNEL.API_CALLBACK.SUBTITLE')">
      <woot-code :script="inbox.callback_webhook_url" lang="html" />
    </SettingsSection>
  </div>
  <div v-else-if="isAZApiInbox" class="mx-8">
    <SettingsSection title="Configuração Z-API" sub-title="Configure as credenciais da Z-API para WhatsApp">
      <woot-input v-model="zapiInstanceId" class="w-3/4 pb-4" label="Instance ID"
        placeholder="Digite o Instance ID da Z-API" :disabled="true" />

      <woot-input v-model="zapiToken" class="w-3/4 pb-4" label="Token" placeholder="Digite o Token da Z-API"
        type="password" />

      <woot-input v-model="zapiClientToken" class="w-3/4 pb-4" label="Client Token"
        placeholder="Digite o Client Token da Z-API" type="password" />

      <woot-input v-model="zapiPhoneNumber" class="w-3/4 pb-4" label="Número do WhatsApp"
        placeholder="Ex: +5511999999999" :disabled="true" />

      <label class="flex items-center space-x-2">
        <woot-switch id="zapiOpenAsPending" v-model="zapiOpenAsPending" />
        <span>Abrir como pendente</span>
      </label>
    </SettingsSection>

    <SettingsSection title="Webhook URL"
      sub-title="Configure esta URL nos webhooks da sua instância Z-API para receber mensagens e status.">
      <woot-code :script="inbox.callback_webhook_url" lang="html" class="mt-4" />
    </SettingsSection>

    <SettingsSection :show-border="false">
      <woot-button color-scheme="primary" :loading="$store.getters['inboxes/getUIFlags'].isUpdating"
        @click="updateZApiSettings">
        Salvar Configurações Z-API
      </woot-button>
    </SettingsSection>
  </div>
  <div v-else-if="isAWebWidgetInbox">
    <div class="mx-8">
      <SettingsSection :title="$t('INBOX_MGMT.SETTINGS_POPUP.MESSENGER_HEADING')"
        :sub-title="$t('INBOX_MGMT.SETTINGS_POPUP.MESSENGER_SUB_HEAD')">
        <woot-code :script="inbox.web_widget_script" lang="html" :codepen-title="`${inbox.name} - Chatwoot Widget Test`"
          enable-code-pen />
      </SettingsSection>

      <SettingsSection :title="$t('INBOX_MGMT.SETTINGS_POPUP.HMAC_VERIFICATION')">
        <woot-code :script="inbox.hmac_token" />
        <template #subTitle>
          {{ $t('INBOX_MGMT.SETTINGS_POPUP.HMAC_DESCRIPTION') }}
          <a target="_blank" rel="noopener noreferrer"
            href="https://www.chatwoot.com/docs/product/channels/live-chat/sdk/identity-validation/">
            {{ $t('INBOX_MGMT.SETTINGS_POPUP.HMAC_LINK_TO_DOCS') }}
          </a>
        </template>
      </SettingsSection>
      <SettingsSection :title="$t('INBOX_MGMT.SETTINGS_POPUP.HMAC_MANDATORY_VERIFICATION')"
        :sub-title="$t('INBOX_MGMT.SETTINGS_POPUP.HMAC_MANDATORY_DESCRIPTION')">
        <div class="flex items-center gap-2">
          <input id="hmacMandatory" v-model="hmacMandatory" type="checkbox" @change="handleHmacFlag" />
          <label for="hmacMandatory">
            {{ $t('INBOX_MGMT.EDIT.ENABLE_HMAC.LABEL') }}
          </label>
        </div>
      </SettingsSection>
    </div>
  </div>
  <div v-else-if="isAPIInbox" class="mx-8">
    <SettingsSection :title="$t('INBOX_MGMT.SETTINGS_POPUP.INBOX_IDENTIFIER')"
      :sub-title="$t('INBOX_MGMT.SETTINGS_POPUP.INBOX_IDENTIFIER_SUB_TEXT')">
      <woot-code :script="inbox.inbox_identifier" />
    </SettingsSection>

    <SettingsSection :title="$t('INBOX_MGMT.SETTINGS_POPUP.HMAC_VERIFICATION')"
      :sub-title="$t('INBOX_MGMT.SETTINGS_POPUP.HMAC_DESCRIPTION')">
      <woot-code :script="inbox.hmac_token" />
    </SettingsSection>
    <SettingsSection :title="$t('INBOX_MGMT.SETTINGS_POPUP.HMAC_MANDATORY_VERIFICATION')"
      :sub-title="$t('INBOX_MGMT.SETTINGS_POPUP.HMAC_MANDATORY_DESCRIPTION')">
      <div class="flex items-center gap-2">
        <input id="hmacMandatory" v-model="hmacMandatory" type="checkbox" @change="handleHmacFlag" />
        <label for="hmacMandatory">
          {{ $t('INBOX_MGMT.EDIT.ENABLE_HMAC.LABEL') }}
        </label>
      </div>
    </SettingsSection>
  </div>
  <div v-else-if="isAnEmailChannel">
    <div class="mx-8">
      <SettingsSection :title="$t('INBOX_MGMT.SETTINGS_POPUP.FORWARD_EMAIL_TITLE')"
        :sub-title="$t('INBOX_MGMT.SETTINGS_POPUP.FORWARD_EMAIL_SUB_TEXT')">
        <woot-code :script="inbox.forward_to_email" />
      </SettingsSection>
    </div>
    <ImapSettings :inbox="inbox" />
    <SmtpSettings v-if="inbox.imap_enabled" :inbox="inbox" />
  </div>
  <div v-else-if="isAWhatsAppChannel && !isATwilioChannel">
    <div v-if="inbox.provider_config" class="mx-8">
      <SettingsSection :title="$t('INBOX_MGMT.SETTINGS_POPUP.WHATSAPP_WEBHOOK_TITLE')"
        :sub-title="$t('INBOX_MGMT.SETTINGS_POPUP.WHATSAPP_WEBHOOK_SUBHEADER')">
        <woot-code :script="inbox.provider_config.webhook_verify_token" />
      </SettingsSection>
      <SettingsSection :title="$t('INBOX_MGMT.SETTINGS_POPUP.WHATSAPP_SECTION_TITLE')"
        :sub-title="$t('INBOX_MGMT.SETTINGS_POPUP.WHATSAPP_SECTION_SUBHEADER')">
        <woot-code :script="inbox.provider_config.api_key" />
      </SettingsSection>
      <SettingsSection :title="$t('INBOX_MGMT.SETTINGS_POPUP.WHATSAPP_SECTION_UPDATE_TITLE')" :sub-title="$t('INBOX_MGMT.SETTINGS_POPUP.WHATSAPP_SECTION_UPDATE_SUBHEADER')
        ">
        <div class="flex items-center justify-between flex-1 mt-2 whatsapp-settings--content">
          <woot-input v-model="whatsAppInboxAPIKey" type="text" class="flex-1 mr-2" :placeholder="$t(
            'INBOX_MGMT.SETTINGS_POPUP.WHATSAPP_SECTION_UPDATE_PLACEHOLDER'
          )
            " />
          <woot-button :disabled="v$.whatsAppInboxAPIKey.$invalid" @click="updateWhatsAppInboxAPIKey">
            {{ $t('INBOX_MGMT.SETTINGS_POPUP.WHATSAPP_SECTION_UPDATE_BUTTON') }}
          </woot-button>
        </div>
      </SettingsSection>
    </div>
  </div>
</template>

<script>
import { useAlert } from 'dashboard/composables';
import inboxMixin from 'shared/mixins/inboxMixin';
import SettingsSection from '../../../../../components/SettingsSection.vue';
import ImapSettings from '../ImapSettings.vue';
import SmtpSettings from '../SmtpSettings.vue';
import { useVuelidate } from '@vuelidate/core';
import { required } from '@vuelidate/validators';

export default {
  components: {
    SettingsSection,
    ImapSettings,
    SmtpSettings,
  },
  mixins: [inboxMixin],
  props: {
    inbox: {
      type: Object,
      default: () => ({}),
    },
  },
  setup() {
    return { v$: useVuelidate() };
  },
  data() {
    return {
      hmacMandatory: false,
      whatsAppInboxAPIKey: '',
      // Z-API data
      zapiInstanceId: '',
      zapiToken: '',
      zapiClientToken: '',
      zapiPhoneNumber: '',
      zapiOpenAsPending: false,
    };
  },
  validations: {
    whatsAppInboxAPIKey: { required },
  },
  watch: {
    inbox() {
      this.setDefaults();
    },
  },
  mounted() {
    this.setDefaults();
  },
  methods: {
    setDefaults() {
      this.hmacMandatory = this.inbox.hmac_mandatory || false;

      // Set Z-API defaults
      if (this.isAZApiInbox) {
        this.zapiInstanceId = this.inbox.instance_id || '';
        this.zapiToken = this.inbox.token || '';
        this.zapiClientToken = this.inbox.client_token || '';
        this.zapiPhoneNumber = this.inbox.phone_number || '';
        this.zapiOpenAsPending = this.inbox.open_as_pending || false;
      }
    },
    handleHmacFlag() {
      this.updateInbox();
    },
    async updateInbox() {
      try {
        const payload = {
          id: this.inbox.id,
          formData: false,
          channel: {
            hmac_mandatory: this.hmacMandatory,
          },
        };
        await this.$store.dispatch('inboxes/updateInbox', payload);
        useAlert(this.$t('INBOX_MGMT.EDIT.API.SUCCESS_MESSAGE'));
      } catch (error) {
        useAlert(this.$t('INBOX_MGMT.EDIT.API.ERROR_MESSAGE'));
      }
    },
    async updateWhatsAppInboxAPIKey() {
      try {
        const payload = {
          id: this.inbox.id,
          formData: false,
          channel: {},
        };

        payload.channel.provider_config = {
          ...this.inbox.provider_config,
          api_key: this.whatsAppInboxAPIKey,
        };

        await this.$store.dispatch('inboxes/updateInbox', payload);
        useAlert(this.$t('INBOX_MGMT.EDIT.API.SUCCESS_MESSAGE'));
      } catch (error) {
        useAlert(this.$t('INBOX_MGMT.EDIT.API.ERROR_MESSAGE'));
      }
    },
    // Z-API methods
    async updateZApiSettings() {
      try {
        const payload = {
          id: this.inbox.id,
          formData: false,
          channel: {
            instance_id: this.zapiInstanceId,
            token: this.zapiToken,
            client_token: this.zapiClientToken,
            phone_number: this.zapiPhoneNumber,
            open_as_pending: this.zapiOpenAsPending
          }
        };

        await this.$store.dispatch('inboxes/updateInbox', payload);
        useAlert('Configurações Z-API atualizadas com sucesso!');
      } catch (error) {
        useAlert(error.message || 'Erro ao atualizar configurações Z-API');
      }
    },
  },
};
</script>